import { Controller } from "@hotwired/stimulus";

// SMS segment sizes: 160 chars for GSM-7, 70 for UCS-2
// Multi-part: 153 chars per segment (GSM-7), 67 per segment (UCS-2)
const GSM_SINGLE = 160;
const GSM_MULTI = 153;

export default class extends Controller {
  static targets = ["input", "output"];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasOutputTarget) return;

    const length = this.inputTarget.value.length;
    if (length === 0) {
      this.outputTarget.textContent = "";
      return;
    }

    const segments = length <= GSM_SINGLE ? 1 : Math.ceil(length / GSM_MULTI);
    const label = segments === 1 ? "part" : "parts";
    this.outputTarget.textContent = `${length} chars \u00B7 ${segments} SMS ${label}`;
  }
}
